(() => {
  const BFMHeroVideo = () => {
    const props = {
      selectors: {
        component: "bfm-hero-video",
        videoPlayer: "bfm-hero-video__video-player",
        videoPoster: "bfm-hero-video__video-poster",
      },
      ytUrl: "https://www.youtube.com/iframe_api",
    };

    const processHeader = ($element) => {
      const header = document.querySelector("header");
      if (header) {
        if ($element.querySelector(".js-embed-header")) {
          header.classList.add("c-container-collapsed");
        }
      }
    };

    const loadYTPlayer = () => {
      bcl.u.loadScript({
        src: props.ytUrl,
        type: "text/javascript",
        defer: true,
      });
    };

    const handleVideoPoster = (element) => {
      const videoPlayerElem = element.querySelector("." + props.selectors.videoPlayer);
      const videoPlayerPoster = element.querySelector("." + props.selectors.videoPoster);

      if (!videoPlayerElem) {
        return;
      }

      const player = new window.YT.Player(videoPlayerElem, {
        videoId: videoPlayerElem.getAttribute("data-video-id"),
        width: "1080",
        height: "720",
        playerVars: {
          color: "white",
          rel: 0,
          playsinline: 1,
        },
      });

      videoPlayerPoster.addEventListener("click", (e) => {
        player.playVideo();
        setTimeout(() => {
          e.target.remove();
        }, 250);
      });
    };

    const init = () => {
      const heroElements = Array.from(document.getElementsByClassName(props.selectors.component));
      if (heroElements.length > 0) {
        loadYTPlayer();
        window.onYouTubeIframeAPIReady = () => {
          heroElements.forEach((element) => {
            processHeader(element);
            handleVideoPoster(element);
          });
        };
      }
    };

    document.addEventListener("DOMContentLoaded", init);
  };

  BFMHeroVideo();
})();
